module.exports = __webpack_public_path__ + "img/vdw_burri.6eda512d.png";